export const FETCH_REQUESTED = 'FETCH_JEWELLERY_COIN_PRICE_REQUESTED';
export const FETCH_COMPLETED = 'FETCH_JEWELLERY_COIN_PRICE_COMPLETED';
export const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
